import React from 'react';
import { Login as LoginComponent } from 'components/User';

const Login = () => (
    <LoginComponent />
);

export default Login;
